// @ts-nocheck
import { loadScript } from 'common-utils';

import { TrackingTool } from '../tracking-tool';

type TrackdeskFunction = {
  // eslint-disable-next-line
  (...args: any[]): void;
  // eslint-disable-next-line
  q?: any[];
};

declare global {
  interface Window {
    // eslint-disable-next-line
    TrackdeskObject?: any[];
    trackdesk?: TrackdeskFunction;
  }
}

export class Trackdesk implements TrackingTool {
  private readonly _id: string;
  public isOn = false;
  constructor(id: string) {
    this._id = id;
    this.turnOn();
  }
  getName = () => 'trackdesk';

  turnOn = async () => {
    if (this.isOn) {
      return;
    }
    if (typeof window !== 'undefined') {
      try {
        await loadScript('https://cdn.trackdesk.com/tracking.js');

        (function (t, d, k) {
          (t[k] = t[k] || []).push(d);
          t[d] =
            t[d] ||
            t[k].f ||
            function () {
              (t[d].q = t[d].q || []).push(arguments);
            };
        })(window, 'trackdesk', 'TrackdeskObject');
        // eslint-disable-next-line
        const IS_CHINA_USER = process.env.NEXT_PUBLIC_CHINA === 'true';
        const cidDomain = IS_CHINA_USER ? '.editage.cn' : '.paperpal.com';
        if (window.trackdesk) {
          window.trackdesk(this._id, 'click', {
            _meta: { cidDomain: cidDomain },
          });
        }
        this.isOn = true;
      } catch (error) {
        console.error('Failed to load Trackdesk script:', error);
      }
    }
  };
  turnOff = async () => {};
}
